import { useMemo } from 'react';
import { some } from 'lodash';
import { useDrawerStack } from './queryParams/useDrawerStack';

export const useIsSimulatorInDrawerStack = () => {
    const { stack } = useDrawerStack();

    const isSimulatorInStack = useMemo(
        () => some(stack, ({ path }) => path && path.includes('campaign-simulator')),
        [stack]
    );

    return isSimulatorInStack;
};
